var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productActions"},[(_vm.showComparision)?_c('div',{class:[
      'productActions__action',
      { 'productActions__action--showMobile': _vm.showMobileComparision },
    ]},[_c('span',{staticClass:"icon-comparison"})]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('div',{staticClass:"productActions__action productActions__action--list"},[_c('button',{class:['productActions__iconList', { active: _vm.isOnList }],on:{"click":function($event){return _vm.toggleProductFromList({ product: _vm.product, isOnList: _vm.isOnList })}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }